import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faEdit, faTrashAlt,
} from '@fortawesome/free-solid-svg-icons';
import { AttachmentsCellProps, BooleanFunctionType } from '../../../../../../core/types/coreTypes';
import { PermissionEnum } from '../../../../../../core/enums/dictionariesEnums';
import { useAppDispatch } from '../../../../../../store/hooks';
import ConfirmationModal from '../../../../../../core/components/confirmation-modal/ConfirmationModal';
import {
  deleteOrderAttachmentThunk, editOrderAttachment,
  getOrderAttachmentById,
} from '../../../../../../store/thunks/orders/orderAttachmentsThunks';
import usePermission from '../../../../../../permissions-handling/permissionHook';
import AttachmentsRow from '../../../../../../common/components/attachments-table/AttachmentsRow';

const OrderAttachmentCell:React.FC<AttachmentsCellProps> = ({
  attach,
  openEditModal,
  checked,
  checkRow,
}) => {
  const { id } = useParams();
  const allowedManage = usePermission(PermissionEnum.OrderEditFields);

  const dispatch = useAppDispatch();
  const [isModal, setModal] = useState(false);

  const actions = [
    {
      label: 'Edit comment',
      icon: <FontAwesomeIcon icon={faEdit} />,
      key: 'editComment',
      onClick: () => openEditModal(),
    },
    {
      label: 'Delete file',
      key: 'deleteFile',
      icon: <FontAwesomeIcon icon={faTrashAlt} />,
      onClick: () => setModal(true),
    },
  ];

  const changeShowInLinkedJobsToggle = (attachmentId: number, value: boolean, setSwitchLoading: BooleanFunctionType) => {
    if (id) {
      dispatch(editOrderAttachment({
        id: attachmentId,
        orderId: +id,
        data: { showInLinkedJobs: value },
        setSwitchLoading,
      }));
    }
  };
  return (
    <>
      <ConfirmationModal
        isVisible={isModal}
        onCancel={() => setModal(false)}
        confirmHandler={() => id && dispatch(deleteOrderAttachmentThunk({
          id: attach.id,
          orderId: +id,
          closeModal: () => setModal(false),
        }))}
      />
      <AttachmentsRow
        allowedManage={!!allowedManage}
        attachment={attach}
        checked={checked}
        checkRows={checkRow}
        onClick={(attachId) => id && dispatch(getOrderAttachmentById({
          id: attachId,
          orderId: +id,
        }))}
        actions={actions}
        changeShowInLinkedJobsToggle={changeShowInLinkedJobsToggle}
      />
    </>
  );
};

export default OrderAttachmentCell;
